import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/65_card_back_golden_bird/65_card_back_golden_bird"
 * Contains 1 texture(s)
 */
export class CardsBacks65CardBackGoldenBirdAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/65_card_back_golden_bird/65_card_back_golden_bird';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '65_golden_bird.png'
    ] as const;
}
